<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="rows"
      :items-per-page="5"
      v-bind="$attrs"
    >
      <template #[`item.missing_translations`]="{ item }">
        <v-icon
          v-if="item.language_code !== defaultTranslation.language_code"
          :color="isMissingTranslations(item) ? 'orange' : 'green'"
          v-text="isMissingTranslations(item) ? 'mdi-alert-circle' : 'mdi-check-circle'"
        />
      </template>
      <template #[`item.language.name`]="{ item }">
        <span v-if="item.language_code === defaultTranslation.language_code">
          {{ allLanguages[item.language_code].name }} <v-chip
            x-small
            class="ml-2"
          >{{ $t('Default language') }}</v-chip>
        </span>
        <span v-else>
          {{ allLanguages[item.language_code].name }}
        </span>
      </template>
      <template #[`item.name`]="{ item }">
        <v-edit-dialog
          @open="() => nameForm.name = item.name"
          @save="updateName(item)"
        >
          <a
            style="border-bottom: 1px dashed currentColor; text-decoration: none;"
            href="javascript:void(0)"
          >
            {{ item.name || $t('Enter translation') }}
          </a>
          <template #input>
            <v-text-field
              v-model="nameForm.name"
              dense
              class="pt-4"
              :label="$t('Edit')"
              outlined
              single-line
            />
          </template>
        </v-edit-dialog>
      </template>
      <template #[`item.description`]="{ item }">
        <v-edit-dialog
          large
          @open="() => descriptionForm.description = item.description"
          @save="updateDescription(item)"
        >
          <a
            style="border-bottom: 1px dashed currentColor; text-decoration: none;"
            href="javascript:void(0)"
          >
            {{ item.description || $t('Enter translation') }}
          </a>
          <template #input>
            <v-textarea
              v-model="descriptionForm.description"
              dense
              class="pt-4"
              outlined
              autofocus
              hide-details
            />
          </template>
        </v-edit-dialog>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    props: {
      faqId: {
        type: Number,
        required: true
      },
      modelId: {
        type: Number,
        required: true
      },
      defaultTranslation: {
        type: Object,
        required: true
      },
      translations: {
        type: Array,
        required: true
      },
      isSubcategory: {
        type: Boolean
      },
      allLanguages: {
        type: Object,
        required: true
      },
      missingTranslations: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        headers: [
          { text: '', value: 'missing_translations', width: 70 },
          { text: this.$t('Language'), value: 'language.name' },
          { text: this.$t('Name'), value: 'name' },
          { text: this.$t('Description'), value: 'description' },
        ],
        rows: [],

        deleteForm: this.$inertia.form({ }),

        nameForm: this.$inertia.form({
          name: '',
        }),

        descriptionForm: this.$inertia.form({
          description: ''
        })
      }
    },

    created() {
      this.rows = [
        this.defaultTranslation,
        ...this.translations
      ];
    },

    methods: {
      updateName(translation) {
        if (this.nameForm.value === translation.name) {
          return;
        }

        const url = this.getUpdateUrl(translation.id);

        this.nameForm.patch(url);
      },

      updateDescription(translation) {
        if (this.descriptionForm.description === translation.description) {
          return;
        }

        const url = this.getUpdateUrl(translation.id);

        this.descriptionForm.patch(url);
      },

      getUpdateUrl(translationId) {
        if (! this.isSubcategory) {
          return this.route('faq.category-translation.update', {
            faq: this.faqId,
            category: this.modelId,
            categoryTranslation: translationId
          });
        } else {
          return this.route('faq.subcategory-translation.update', {
            faq: this.faqId,
            subcategory: this.modelId,
            subcategoryTranslation: translationId
          });
        }
      },

      isMissingTranslations(model) {
        if (this.isSubcategory) {
          return this.missingTranslations.subcategories[this.modelId][model.language_code];
        } else {
          return this.missingTranslations.categories[this.modelId][model.language_code];
        }
      }
    }
  }
</script>